export function isTimeOffPartialDay(daysArr) {
  for (const day of daysArr) {
    if (day.AMOUNT !== 8) {
      return true;
    }
  }

  return false;
}
